import clsBaseGlobal from './base'
import string from '@lib/string'

const arrFillable = [
    "cpy_name",
    "cpy_name_short",
    "cpy_code",
    "cpy_kvk",
    "cpy_email",
    "cpy_website",
    "cpy_phone",
    "cpy_fax",
    "cpy_vatnumber",
    "cpy_email_frombox",
    "cpy_email_frombox_name",
    "cpy_email_replyto",
    "cpy_email_alias",
    "iban1",
    "iban2",
    "ibang",
    "hasMollie",
    "adr_street",
    "adr_street_number",
    "adr_zipcode",
    "adr_city",
    "country_code",
    "country_name",

    "replyto_email_tender",
    "replyto_email_contract",
    "replyto_email_invoice",
];


class clsGlobalCompany extends clsBaseGlobal {

    // From company settings edit
    cpy_name               = null;
    cpy_name_short         = null;
    cpy_code               = null;
    cpy_kvk                = null;
    cpy_email              = null;
    cpy_website            = null;
    cpy_phone              = null;
    cpy_fax                = null;
    cpy_vatnumber          = null;
    cpy_email_frombox      = null; // + settings
    cpy_email_frombox_name = null;
    cpy_email_replyto      = null;

    cpy_email_alias        = null;
    iban1                  = null;
    iban2                  = null;
    ibang                  = null;
    hasMollie              = false; // + settings

    adr_street             = null;
    adr_street_number      = null;
    adr_zipcode            = null;
    adr_city               = null;
    country_code           = null;
    country_name           = null; // + settings

    replyto_email_tender    = null;
    replyto_email_contract  = null;
    replyto_email_invoice   = null;

    get fillable() { return arrFillable; }

    fill(data) {
        data = data ||{};
        data.hasMollie = !!data.hasMollie;
        return super.fill(data);
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Helpers
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////
    get purchasePortalKvkAddress() {
        return `${this.cpy_kvk}@facturen.optimit.nl`;
    }
    get purchasePortalAliasAddress() {
        return `${this.cpy_email_alias}@facturen.optimit.nl`;        
    }
    get isValidKvk() {
        return string.isValidDutchCocNumber(this.cpy_kvk);
    }
    get isValidVat() {
        return string.isValidDutchVatNumber(this.cpy_vatnumber);
    }

    /**
     * return the ibans in array format (not the g account)
     * @returns 
     */
    getIbanArray() {
        let arr = [];

        if (string.isNotEmpty(this.iban1)) {
            arr.push(this.iban1);
        }
        if (string.isNotEmpty(this.iban2)) {
            arr.push(this.iban2);
        }
        return arr;
    }

}

export default clsGlobalCompany;